<template>
  <!-- 横向商品 -->
  <div class="order-block">
    <div class="order-top" @click="goOrderDetails">
      <span class="order-time">订单编号：{{ info.code }}</span>

      <span class="order-type" v-if="info.state == 0">等待付款</span>
      <span class="order-type" v-else-if="info.state == 1">已兑换待发货</span>
      <span class="order-type" v-else-if="info.state == 2">已兑换已发货</span>
      <span class="order-type" v-else>兑换已完成</span>
      <!-- <span class="order-type" v-else-if="{{info.state == 4}}">交易已关闭</span>
            <span class="order-type" v-else-if="{{info.state == 5}}">兑换已完成</span> -->
      <!-- -1：已取消，0：未支付，1：已支付待发货，2：已发货 -->
    </div>

    <div class="img-text-row" v-for="(item, index) in info.products" :key="index" @click="goOrderDetails">
      <div class="row-goods-img">
        <img
          :src="item.productImage"
          alt=""
        />
      </div>

      <div class="row-goods-info">
        <!-- <p class="row-goods-leble">
          <span class="rx">热销</span> <span class="xs">热销</span>
        </p> -->
        <p class="row-goods-name">
          {{item.productName}}
        </p>
        <p class="row-goods-des">
           
        </p>
        <p class="row-goods-class"> {{item.sku}}</p>
        <!-- <p class="row-goods-original-price">¥ 360.00</p> -->
        <p class="row-goods-price">
          共 {{item.quantity}}件 
          <!-- <span>小计</span> -->
           <!-- <span class="price-r">¥  {{info.totalAmount}}</span> -->
        </p>
      </div>
    </div>

    <div class="foot-btn-block">
      <!-- <div class="btn" @click="goaddss">测试查看地址</div> -->
      <!-- -1：已取消，0：未支付，1：已支付待发货，2：已发货 -->
      <!-- <div class="btn" v-if="info.state == 0" @click="" >取消订单</div> -->
      <!-- <div class="btn" v-if="info.state == 4|| info.state == 5" @click="" >删除订单</div> -->
      <!-- <div class="btn" v-if="info.state == 2" @click="goExpress">查看物流</div> -->

      <!-- <div class="btn btns" hover-class="c-btn-class" v-if="{{info.state == 0}}">立即支付</div> -->
      <!-- <div class="btn btnf" hover-class="c-btn-class"  v-if="{{info.state == 2}}" bindtap="goExpress">查看物流</div> -->

      <div
        class="btn"
        v-if="info.state == 0 || info.state == 1 || info.state == 2"
        @click="onClickRight"
      >
        联系我们
      </div>

      <div class="btn btnf" v-if="info.state == 1 && time == 0" @click="remind">
        提醒发货
      </div>
      <div class="btn btnf op" v-if="info.state == 1 && time > 0">
        {{ time }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "imgTextRow",
  props: {
      info: {
      type: Object,
      default: {
        id: '1',
        state: 1, //1 未付款 2 已付款 未发货 3 待收货 4 已完成  5 易关闭
        // -1：已取消，0：未支付，1：已支付待发货，2：已发货
        goodsAmount: 0,
        actEndTime:'',
        totalAmount: 0,
        payAmount: 0,
        state: 0,
        products: [
          {
            productId: 0,
            skuId: 0,
            productName: "",
            productImage: "",
            sku: "",
            quantity: 0,
            salePrice: 0,
            freeAmount: 0,
            payAmount: 0,
            supplierName: ""
          }
        ]
      },
    },
  },
  components: {},
  data() {
    return {
      time: 0,
      currentTime: 20,
      
    };
  },
  created() {},
  mounted() {},
  methods: {
    // 提醒发货
    remind() {
      var that = this;
      var currentTime = that.currentTime;
      this.$toast({
        message: "已提醒商家~",
      });
      that.time = currentTime;

      let interval = setInterval(function () {
        that.time = currentTime - 1;
        currentTime--;
        if (currentTime <= 0) {
          clearInterval(interval);
          that.time = 0;
          that.currentTime = 20;
        }
      }, 1000);
    },
    onClickRight() {
       this.MakeCall() //拨打电话
    },
     goOrderDetails(){
    this.$router.push({ name:'exchange-order-details',
          query:{
            id:this.info.id
          }
          });
  },
  },
};
</script>

<style lang="scss" scoped>
.order-block {
  // background-color: peachpuff;

  background: #ffffff;
  box-shadow: 0px 1px 3px rgba(69, 79, 99, 0.06);
  opacity: 1;
  border-radius: 3px;

  margin: 10px 0;

  .order-top {
    padding: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .order-time {
    font-size: 10px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    line-height: 17px;
    color: #78849e;
  }
  .order-type {
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    line-height: 20px;
    color: #ff5000;
  }
}

// 横向
.img-text-row {
  //   width: 100%;
  box-sizing: border-box;
//   height: 150px;
  border-bottom: 1px solid #eeeeee;
  //   background-color: #fff;
  //    background-color: palegoldenrod;
  //   margin-bottom: 5px;
  margin: 5px 10px;
  //   padding: 5px 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .row-goods-img {
    width: 125px;
    height: 125px;
    img {
      width: 100%;
      height: 100%;
    }
  }

  .row-goods-info {
    width: 200px;
    height: 100%;
    padding: 5px 0;
    text-align: left;
    //  background-color: paleturquoise;

    .row-goods-leble {
      font-size: 10px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      line-height: 17px;
      color: #ffffff;
      letter-spacing: 1px;
      text-align: left;

      span {
        padding: 1px 7px;
        border-radius: 3px;
      }

      .rx {
        background-color: #e95970;
      }
      .xs {
        margin-left: 3px;
        background-color: #b80009;
      }
    }
    .row-goods-name {
      font-size: 18px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      line-height: 30px;
      color: #454f63;

      letter-spacing: 1px;
      display: -webkit-box; /*作为弹性伸缩盒子模型显示*/
      -webkit-line-clamp: 1; /*显示的行数；如果要设置2行加...则设置为2*/
      overflow: hidden; /*超出的文本隐藏*/
      text-overflow: ellipsis; /* 溢出用省略号*/
      -webkit-box-orient: vertical; /*伸缩盒子的子元素排列：从上到下*/
    }
    .row-goods-des {
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      line-height: 20px;
      color: #78849e;
      letter-spacing: 1px;
      display: -webkit-box; /*作为弹性伸缩盒子模型显示*/
      -webkit-line-clamp: 1; /*显示的行数；如果要设置2行加...则设置为2*/
      overflow: hidden; /*超出的文本隐藏*/
      text-overflow: ellipsis; /* 溢出用省略号*/
      -webkit-box-orient: vertical; /*伸缩盒子的子元素排列：从上到下*/
    }
    .row-goods-class {
      display: inline-block;
      background: #f9f9f9;
      opacity: 1;
      border-radius: 3px;
      padding: 2px 5px;
      letter-spacing: 1px;
      font-size: 10px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      line-height: 17px;
      color: #bbbbbb;
    }
    .row-goods-original-price {
      text-decoration: line-through;
      font-size: 10px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      line-height: 17px;
      color: #cccccc;
    }
    .row-goods-price {
      margin-top: 20px;
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 21px;
      color: #999999;
      //   display: flex;
      //   justify-content: space-between;
      //   align-items: center;
      span {
        font-size: 15px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        line-height: 26px;
        color: #454f63;
      }
      .price-r {
        float: right;
      }
    }
  }
}

.foot-btn-block {
  padding: 0 10px;
  height: 55px;
  background-image: url("https://qiniu.zdyxjx.com/minizdyxbg.png");
  background-repeat: no-repeat;
  background-size: 65px 55px;
  background-position: 0 0;
  display: flex;
  align-items: center;

  justify-content: flex-end;
}
.btn {
  width: 90px;
  height: 25px;
  border: 1px solid #78849e;
  opacity: 1;
  border-radius: 12px;
  margin-left: 10px;
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 500;

  color: #78849e;
  display: flex;
  justify-content: center;
  align-items: center;
}
.btns {
  border: 1px solid #03a8c0;
  color: #03a8c0;
}
.btnf {
  border: 1px solid #03a8c0;
  background-color: #03a8c0;
  color: #fff;
}
.c-btn-class {
  background-color: #e2e8ed !important;
  color: #ff5000 !important;
  opacity: 0.9 !important;
  transform: scale(0.98, 0.98) !important;
}
.op {
  opacity: 0.5 !important;
}
</style>
